import { Checkbox, Field, Label } from "@headlessui/react"

type CheckboxProps = {
    checked: boolean
    onChange: (checked: boolean) => void
    label?: string
}

export function CustomCheckbox({ checked, onChange, label }: CheckboxProps) {
    return (
        <Field className="inline-flex items-center gap-3">
            <Checkbox
                className={`
                    group peer flex size-4 cursor-pointer rounded-full
                    bg-bonza-pale-t-7 p-1 shadow-sm

                    focus:ring-bonza-primary
                `}
                checked={checked}
                onChange={onChange}
            >
                <span
                    className={`
                        group size-full rounded-full bg-none

                        group-data-[checked]:bg-bonza-pale

                        peer-checked:bg-bonza-pale
                    `}
                />
            </Checkbox>
            {label && (
                <Label className="cursor-pointer text-sm text-bonza-pale">
                    {label}
                </Label>
            )}
        </Field>
    )
}
